import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Assessor } from 'src/app/models/Assessor';

@Component({
  selector: 'app-assessors-close',
  templateUrl: 'assessors-close.component.html',
  styleUrls: ['./assessors-close.component.less', '../../../shared/common.less'],
})

export class AssessorsCloseComponent implements OnInit {
  @Input() isValidated: boolean = false;
  @Input() assessors: Array<Assessor> = [];
  @Output() validateEvent = new EventEmitter<boolean>();
  @Input() testStepStatus: string = "";
  isExpanded: boolean = true;
  activeButton: number = 0;

  setActiveButton(buttonNumber: number) {
    this.activeButton = buttonNumber;
  }

  testConfirmation(confirmation: boolean ) {
    this.validateEvent.emit(confirmation);
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  ngOnInit(): void {
  }
}
